import { IProfileEntity, IProfileControls, IProfileDto } from "../interfaces/profile-controls.interface";
import { Injectable } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { EntityFormModel } from "@app/kernel/form/classes/entity-form-model";
import { IOnFormModelInit } from "@app/kernel/form/interfaces/form-model.interfaces";
import { TControlsValue } from "@app/kernel/form/types/form-controls-utils.types";

@Injectable()
export class ProfileFormModel extends EntityFormModel<IProfileEntity, IProfileDto, IProfileControls> implements IOnFormModelInit<IProfileControls> {
  constructor() {
    super();
  }

  onInit() {
    console.log("init");
  }

  entityToFormValue(entity?: Partial<IProfileEntity> | null): TControlsValue<IProfileControls> {
    return {
      name: entity?.name ?? "",
      surname: entity?.surname ?? "",
      mobile: entity?.mobile ?? "",
      email: entity?.email ?? "",
      emailVerified: entity?.emailVerified ?? false,
    };
  }

  formValueToDtoInput(formValue: TControlsValue<IProfileControls>): IProfileDto {
    return {
      name: formValue.name,
      surname: formValue.surname,
      mobile: formValue.mobile,
      email: formValue.email,
      emailVerified: formValue.emailVerified,
    };
  }

  protected createFormGroup(initialValue: TControlsValue<IProfileControls>): FormGroup<IProfileControls> {
    return new FormGroup<IProfileControls>({
      name: new FormControl(initialValue.name, { nonNullable: true, validators: this.buildValidator(() => ({ isNotEmpty: {} })) }),
      surname: new FormControl(initialValue.surname, { nonNullable: true, validators: this.buildValidator(() => ({ isNotEmpty: {} })) }),
      mobile: new FormControl(initialValue.mobile, { nonNullable: true }),
      email: new FormControl(initialValue.email, { nonNullable: true }),
      emailVerified: new FormControl(initialValue.emailVerified, { nonNullable: true }),
    });
  }
}
